import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=4d19e0f8&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=ts"
export * from "./DocumentView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=4d19e0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19e0f8",
  null
  
)

export default component.exports